import Request from "./Request";
import axios from "axios";
const config = require("../../configs/config.json");
const gain = require("../../configs/gain.json");

const createActivityPart = (activityId, activityPart) => {
    return Request("post", `/exam/activity/part/${activityId}`, activityPart);
};

const getAllActivityPart = () => {
    return Request("get", "/exam/activity/part/");
};

const updateActivityPart = (activityPartId, activityPart) => {

    return Request("put", `/exam/activity/part/${activityPartId}`, activityPart);
};

const getAllActiveActivityPart = () => {
    return Request("get", "/exam/activity/part/active/");
};

const getActivityPartById = (activityPartId) => {
    return Request("get", `/exam/activity/part/${activityPartId}`);
};

const getActivityPartByActivity = (activityPartId) => {
    return Request("get", `/activity/part/by-activity/${activityPartId}`);
};

const createActivity = (examId, activity) => {
    return Request("post", `/exam/activity/${examId}`, activity);
};

const getAllActivity = () => {
    return Request("get", `/exam/activity/`);
};

const updateActivity = (activityId, activity) => {
    return Request("put", `/exam/activity/${activityId}`, activity);
};

const deleteActivity = (activityId, examId) => {
    return Request("delete", `/exam/activity/${activityId}/${examId}`);
};

const getAllActiveActivity = (userId) => {
    return Request("get", `/activity/active/`);
};

const getActivityById = (activityId) => {
    return Request("get", `/exam/activity/${activityId}`);
};

const getActivityByExam = (examId) => {
    return Request("get", `/exam/activity/part/by-exam/${examId}`);
};

const addActivityPartToActivity = (activityId, activityPartId) => {
    return Request("get", `/exam/activity/add-part/${activityId}/${activityPartId}`);
};

const removeActivityPartToActivity = (activityId, activityPartId) => {
    return Request("get", `/exam/activity/remove-part/${activityId}/${activityPartId}`);
};

const createExam = (exam) => {
    return Request("post", `/exam/`, exam);
};

const deleteExam = (examId) => {
    return Request("delete", `/exam/${examId}`);
};

const getAllExam = async () => {
    return Request("get", `/exam/`);
};

const getExamsWithAssignments = () => {
    return Request("get", "/exam/with-assignments/");
};

const updateExam = (examId, exam) => {
    return Request("put", `/exam/${examId}`, exam);
};

const getAllActiveExam = () => {
    return Request("get", `/exam/active/`);
};

const getExamById = (examId) => {
    return  Request("get", `/exam/${examId}`);
};

const addActivityToExam = (examId, activityId) => {
    return Request("get", `/exam/activity/add-activity/${examId}/${activityId}`);
};

const removeActivityToExam = (examId, activityId) => {
    return Request("get", `/exam/activity/remove-activity/${examId}/${activityId}`);
};

const startExam = (studentId, name, lastname, email, mobilePhone, school, grade, branch, examId) => {
    return Request("get", `/exam/start/student/${studentId}/name/${name}/lastname/${lastname}/email/${email}/mobilePhone/${mobilePhone}/school/${school}/grade/${grade}/branch/${branch}/exam/${examId}`);
};


const getGains = async () => {
    return gain;

    try {
        const res = await axios.get("https://app.eltaexams.com/api/speech/kazanimlar", {
            params: { sinif: 0 },
            headers: {
                'Token': 'Bearer ad070e63-9299-4df7-9476-d8358d33bca9',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',  // CORS header
            },
            withCredentials: false
        });
        return res;
    } catch (error) {
        console.error('Hata:', error.response?.data || error.message);
    }

};



const addGain = (params) => {
    return Request("post", `/exam/gain/add/`, params);
};
const removeGain = (params) => {
    return Request("post", `/exam/gain/remove/`, params);
};





const getExamResults = (examId) => {
    return Request("get", `/result/summary/${examId}`);
};

const getExamFilterSchools = (examId) => {
    return Request("get", `/exam/${examId}/filter/schools`);
};

const getExamFilterGrades = (examId, schoolId) => {
    const params = new URLSearchParams({ schoolId }).toString();
    return Request("get", `/exam/${examId}/filter/grades?${params}`);
};

const getExamFilterBranches = (examId, schoolId, grade) => {
    const params = new URLSearchParams({ schoolId, grade }).toString();
    return Request("get", `/exam/${examId}/filter/branches?${params}`);
};

const getExamFilterStudents = (examId, schoolId, grade, branchId) => {
    const params = new URLSearchParams({ schoolId, grade, branchId }).toString();
    return Request("get", `/exam/${examId}/filter/students?${params}`);
};

const recalculateBySchool = (examId, schoolId) => {
    return Request("post", `/result/recalculate/school?examId=${encodeURIComponent(examId)}&schoolId=${encodeURIComponent(schoolId)}`, null);
};

const recalculateByStudent = (examId, studentId) => {
    return Request("post", `/result/recalculate/student?examId=${encodeURIComponent(examId)}&studentId=${encodeURIComponent(studentId)}`, null);
};

const recalculateBySchoolAndBranch = (examId, schoolId, branchId) => {
    return Request("post", `/result/recalculate/school/branch?examId=${encodeURIComponent(examId)}&schoolId=${encodeURIComponent(schoolId)}&branchId=${encodeURIComponent(branchId)}`, null);
};

const recalculateBySchoolAndGrade = (examId, schoolId, grade) => {
    return Request("post", `/result/recalculate/school/grade?examId=${encodeURIComponent(examId)}&schoolId=${encodeURIComponent(schoolId)}&grade=${encodeURIComponent(grade)}`, null);
};

const getChangedAnswerOrScore = (examId, schoolId) => {
    const params = new URLSearchParams({ examId, schoolId }).toString();
    return Request("get", `/result/changed-answer-or-score?${params}`);
};

const updateRecalculationActivityPart = (dto) => {
    return Request("patch", "/result/recalculate/activity-part", dto);
};

const deleteStudentAnswerRecords = (studentId, examId) => {
    return Request(
        "delete",
        `/integration/student/${encodeURIComponent(studentId)}/exam/${encodeURIComponent(examId)}/answer-records`
    );
};

const getAssignmentAnswers = (assignmentId) => {
    return Request("get", `/integration/assignment/${assignmentId}/answers`);
};

const getStoragePreviewFileUrl = (recordedFileId) => {
    if (!recordedFileId) return null;
    let token = null;
    try {
        const userStr = localStorage.getItem("user");
        if (userStr) {
            const user = JSON.parse(userStr);
            token = user && user.access_token ? user.access_token : null;
        }
    } catch (e) {}
    const base = config.api.invokeUrl;
    const url = `${base}/storage/preview/file/${recordedFileId}`;
    return token ? `${url}?token=${encodeURIComponent(token)}` : url;
};

const uploadFileToPath = async (formData) => {
    try {
        const response = await axios.post(
            `${config.api.invokeUrl}/storage/upload/file`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return {data: response.data, status: response.status};
    } catch (err) {
        return {err};
    }
};



const deleteActivityPart = (activityId, activityPartId) => {
    return Request("delete", `/exam/activity/part/${activityId}/${activityPartId}`);
};

const ExamService = {
    deleteActivityPart,
    deleteStudentAnswerRecords,
    getExamResults,
    getExamFilterSchools,
    getExamFilterGrades,
    getExamFilterBranches,
    getExamFilterStudents,
    recalculateBySchool,
    recalculateByStudent,
    recalculateBySchoolAndBranch,
    recalculateBySchoolAndGrade,
    getChangedAnswerOrScore,
    updateRecalculationActivityPart,
    getAssignmentAnswers,
    getStoragePreviewFileUrl,
    removeGain,
    addGain,
    createActivityPart,
    getGains,
    getAllActivityPart,
    updateActivityPart,
    getAllActiveActivityPart,
    getActivityPartById,
    getActivityPartByActivity,
    createActivity,
    getAllActivity,
    updateActivity,
    deleteActivity,
    getAllActiveActivity,
    getActivityById,
    getActivityByExam,
    addActivityPartToActivity,
    removeActivityPartToActivity,
    createExam,
    getAllExam,
    getExamsWithAssignments,
    updateExam,
    getAllActiveExam,
    getExamById,
    addActivityToExam,
    removeActivityToExam,
    startExam,
    deleteExam,
    uploadFileToPath
};
export default ExamService;
